import React from "react";
import logo from "../../Assets/images/ldc_logo_new.png";
import DoctorPatient from "../../Assets/images/doctor-patient.jpg";
import { ChevronRight } from "lucide-react";
import {
  Search,
  Building2,
  MapPin,
  Heart,
  Calendar,
  ChevronDown,
  Phone,
  Menu,
} from "lucide-react";
import StethoscopeLogo from "../Logo/logo";
import { NavLink } from "react-router-dom";

function BookingJourney({onNext}) {
  return (
    <div className="app-container">
     

      {/* Purple Banner */}
      <div className="purple-banner">
        <p style={{ margin: "0" }}>Same-day GP appointments available!</p>
      </div>

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-inner">
          <div className="hero-text">
            <h2>
              Private GP
              <br />
              London & UK
            </h2>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="main-features-section">
        <div style={{ paddingTop: "2rem" }}>
        {/* <NavLink to="/book"> */}
          <button className="selectButton" onClick={onNext} >Book an appointment now</button>
          {/* </NavLink> */}
        </div>
        <div className="features-section">
          <div className="feature">
            <Building2 color="#008385" size={70} className="icon-feature" />
            <h3>16 clinics nationwide</h3>
          </div>
          <div className="feature">
            <Heart color="#008385" size={70} className="icon-feature" />
            {/* <StethoscopeLogo size={100} color="#008385" /> */}
            <h3>Open 7 days a week</h3>
          </div>
          <div className="feature">
            <Calendar color="#008385" size={70} className="icon-feature" />
            <h3>Same day GP appointments</h3>
          </div>
        </div>
      </section>

      {/* Featured */}
      <section className="featured-section">
        <h3>London Doctors Clinic is featured in</h3>
      </section>

      <style jsx>
        {`
          .app-container {
            // font-family:  'Lato', sans-serif;
            background-color: white;
          }

          .top-bar {
            background-color: #4b5563;
            color: white;
            padding: 0.5rem 1rem;
            padding-left: 0px;
            font-size: 0.9rem;
          }

          .top-bar-inner {
            margin-left: 10px;
            display: flex;
            justify-content: start;
          }

          .top-links span {
            margin-right: 1.5rem;
            cursor: pointer;
          }

          .main-header {
            background-color: #008385;
            color: white;
          }

          .header-inner {
            margin: auto;
            padding: 1rem;
          }

          .header-rowBooking {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }

          .logo {
            display: flex;
            align-items: center;
            gap: 0.5rem;
          }

          .logo-title {
            font-size: 1.25rem;
            font-weight: bold;
          }

          .logo-subtitle {
            font-size: 0.85rem;
            opacity: 0.9;
          }

          .contact-info {
            text-align: right;
            display: none;
          }

          .contact-call {
            display: flex;
            justify-content: end;
            align-items: center;
            gap: 0.3rem;
          }

          .mobile-menu-icon {
            display: block;
          }

          @media (min-width: 768px) {
            .contact-info {
              display: block;
            }
            .mobile-menu-icon {
              display: none;
            }
          }

          .navigation {
            border-top: 0.05px solid #d3eced;
            background-color: #008385;
            padding: 0.5rem 1rem;
          }
                      @media (max-width: 768px) {
          .navigation {
            display:none;
          }
          }

          .nav-links {
            display: flex;
            gap: 1rem;
            overflow-x: auto;
            white-space: nowrap;
            font-size: 0.9rem;
            align-items: center;
          }

          .nav-item {
            cursor: pointer;
            display: flex;
            align-items: center;
            gap: 0.25rem;
          }

          .search-section {
            background: #f2fafa;
            color: #333;
            padding: 0.4rem;
          }

          .search-inner {
            margin: auto;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 1rem;
          }

          @media (min-width: 768px) {
            .search-inner {
              flex-direction: row;
              justify-content: center;
              align-items: center;
            }
          }

          .search-form {
            display: flex;
            gap: 0.5rem;
          }

          .search-form input {
            padding: 0.5rem;
            border: 1px solid #ccc;
            border-radius: 5px;
          }

          .search-form button {
            padding: 0.5rem;
            border: 1px solid #ccc;
            background: #f0f0f0;
            color: #0d9488;
            border-radius: 5px;
            cursor: pointer;
          }

          button {
            border: 0;
            outline: 0;
            background: transparent;
          }

          .purple-banner {
            background-color: #5d0e93;
            color: white;
            text-align: center;
            padding: 0.4rem;
            font-weight: bold;
          }

          .hero-section {
            background-color: #008385;
            z-index: -1;
          }

          .hero-inner {
            position: relative;
            margin: auto;
            background-image: url("https://pbldcbe.webdezign.uk/static/media/doctor-patient.31b3df054c73cf0734d1.jpg"); /* Replace with your actual image path */
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            height: 52vh; 
          }

          .hero-text {
            position: absolute;
            top: 100px;
            left: 100px;
            max-width: fit-content;
            padding: 1rem;
            background-color: rgba(255, 255, 255, 0.7);
            backdrop-filter: blur(4px);
            text-align: left;
          }

          .hero-text h2 {
            margin: 0;
            padding-right: 2rem;
            font-size: 2.5rem;
            font-weight: 50;
          }

          .hero-text button {
            background: #14b8a6;
            color: white;
            padding: 1rem 2rem;
            border: none;
            border-radius: 9999px;
            font-size: 1rem;
            cursor: pointer;
          }

          .selectButton {
            background: #008385;
            color: white;
            padding: 1rem 2rem;
            border: none;
            border-radius: 9999px;
            font-size: 1rem;
            cursor: pointer;
          }

          .hero-image {
            flex: 1;
          }

          .hero-image img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          .main-features-section {
            position: relative;
            z-index: 2;
            margin-top: -3rem;
            background: #fff;
            margin-inline: 0.8rem;
          }

          .features-section {
            background: #f9fafb;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 2rem;
            padding: 4rem 1rem;
          }

          @media (min-width: 768px) {
            .features-section {
              flex-direction: row;
              justify-content: center;
            }
          }

          .feature {
            background: white;
            padding: 2rem;
            border-radius: 8px;
            text-align: center;
            box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
          }

          .feature h3 {
            color: #0d9488;
            margin-top: 1rem;
          }

          .featured-section {
            color: #008385;
            text-align: center;
            padding: 2rem 1rem;
          }
        `}
      </style>
    </div>
  );
}

export default BookingJourney;
